import { render } from "./CoBrandMeridian.vue?vue&type=template&id=35df618e&scoped=true"
import script from "./CoBrandMeridian.vue?vue&type=script&lang=js"
export * from "./CoBrandMeridian.vue?vue&type=script&lang=js"

import "./CoBrandMeridian.vue?vue&type=style&index=0&id=35df618e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35df618e"]])

export default __exports__